document.addEventListener('DOMContentLoaded', function() {
  function updateElementsVisibility() {
    const urlParams = new URLSearchParams(window.location.search);
    const productType = urlParams.get('typ') || 'book'; // default 'book'

    const typeElements = document.querySelectorAll('[data-type-product]');

    typeElements.forEach(element => {
      const elementType = element.getAttribute('data-type-product');
      
      element.classList.add('type-element-hide');

      if (elementType === productType) {
        element.classList.remove('type-element-hide');
      }
    });

    updateTableZebra();
  }

  function updateTableZebra() {
    document.querySelectorAll('table.table-zebra').forEach(table => {
      const rows = table.querySelectorAll('tbody > tr:not(.type-element-hide)');
      rows.forEach((row, index) => {
        if (index % 2 === 0) {
          row.style.background = '#f8f8f8';
        } else {
          row.style.background = 'transparent';
        }
      });
    });
  }

  document.querySelectorAll('.js-product-variation-switch').forEach(link => {
    link.addEventListener('click', function() {
      setTimeout(updateElementsVisibility, 0);
    });
  });

  updateElementsVisibility();
});
